import type { TotemBorderStyle } from '../types'

export function totemBorderClass(style: TotemBorderStyle): string {
  switch (style.type) {
    case 'rainbow':
      return 'animate-totem-rainbow'
    case 'gradient':
      return 'animate-totem-gradient'
    case 'solid':
      return 'animate-totem-solid'
  }
}

export function totemBorderVars(style: TotemBorderStyle): React.CSSProperties {
  switch (style.type) {
    case 'rainbow':
      return {}
    case 'solid':
      return { '--totem-border': style.color } as React.CSSProperties
    case 'gradient':
      return {
        '--totem-c1': style.colors[0],
        '--totem-c2': style.colors[1],
      } as React.CSSProperties
  }
}
